import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { DialogData } from '../../../../shared/models/dialog-data.model';
import { WebsiteEnvironment } from '../../../../shared/models/website.models';
import { FORM_ERROR_MESSAGES } from '../../../dashboard/dialogs/add-website-dialog/add-website-dialog.const';
import { AddAliasDialogComponent } from '../add-alias-dialog/add-alias-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { InputField } from '../../../../shared/components/input-field/input-field';

@Component({
  selector: 'app-add-subdomain-dialog',
  imports: [
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    InputField,
    MatCheckboxModule,
  ],
  templateUrl: './add-subdomain-dialog.component.html',
  styleUrl: './add-subdomain-dialog.component.scss',
})
export class AddSubdomainDialogComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<AddAliasDialogComponent>);

  readonly data = inject<DialogData & { websiteId: number; domain: string }>(MAT_DIALOG_DATA);

  private fb = inject(FormBuilder);

  readonly errors = FORM_ERROR_MESSAGES;

  form = this.fb.nonNullable.group({
    websiteId: [0, [Validators.required]],
    domain: ['', [Validators.required]],
    websiteEnvironment: [WebsiteEnvironment.ALIAS],
    excludeActions: [],
    emailService: [], // To be checked
    wordpress: [], // Utility control
  });

  ngOnInit(): void {
    this.form.controls.websiteId.setValue(this.data.websiteId);
  }

  submit(): void {
    if (this.form.invalid) return;
    this.dialogRef.close(this.form.getRawValue());
  }

  close(): void {
    this.dialogRef.close();
  }
}
